var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showAssessmentHelpBtn ? _c('div', {
    staticClass: "assessment-help-container",
    attrs: {
      "transition": "fade-05"
    }
  }, [_c('a', {
    staticClass: "assessment-help-button",
    domProps: {
      "innerHTML": _vm._s(_vm.btnAssessment)
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.activityHelpLink($event);
      }
    }
  })]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }